<template>
  <div class="content ht-100v pd-0">dynamic route comp here</div>
</template>

<script>
export default {};
</script>

<style></style>
